import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="book-simple, guide, info, faq"><path d="M19.25 2.75H6.75C5.64543 2.75 4.75 3.64543 4.75 4.75V19.25C4.75 20.3546 5.64543 21.25 6.75 21.25H19.25V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 12V16.75H7C5.75736 16.75 4.75 17.7574 4.75 19C4.75 20.2426 5.75736 21.25 7 21.25H10" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBookSimple;
